import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { LlmLuottokorttilaskuOp, LlmLuottokorttilaskuPyynto, LlmLuottokorttilaskuPyyntoMap } from '../../_jaettu-lemonator/model/llm-luottokorttilasku'

export function callLlmLuottokorttilasku<K extends LlmLuottokorttilaskuOp>(
  firebase: FirebaseLemonator,
  op: K,
  payload: LlmLuottokorttilaskuPyyntoMap[K]['req'],
): Promise<LlmLuottokorttilaskuPyyntoMap[K]['resp']> {
  return firebase.functionsCall<LlmLuottokorttilaskuPyynto, LlmLuottokorttilaskuPyyntoMap[K]['resp']>('llmLuottokorttilasku', { op, payload } as LlmLuottokorttilaskuPyynto)
}
